import { Common } from './common';
export class CommonEventLog extends Common {}
